// removed by extract-text-webpack-plugin
module.exports = {"yk_cmp_container":"_3gqExAdt0nGierVCjGU3dT"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Home/components/QianKun/index.css
// module id = 484
// module chunks = 0